import React from 'react';
import { motion } from 'framer-motion';
export function StickyTopBar() {
  return <div className="fixed top-0 left-0 right-0 z-50 bg-primary text-white py-2 px-4 shadow-md" data-id="element-178">
      <div className="max-w-7xl mx-auto flex items-center justify-center text-sm md:text-base font-medium text-center" data-id="element-179">
        <motion.span animate={{
        scale: [1, 1.2, 1]
      }} transition={{
        repeat: Infinity,
        duration: 2
      }} className="mr-2 inline-block" data-id="element-180">
          🔥
        </motion.span>
        <span data-id="element-181">Oferta especial por tiempo limitado — ¡Aprovechá hoy!</span>
      </div>
    </div>;
}